import axios from "axios";

const token_payment = process.env.VUE_APP_TOKEN_PAYMENT;

// Cliente dedicado al API de pagos (VUE_APP_CHECKOUT_URL, VUE_APP_SUBSCRIPTION_URL,
// VUE_APP_STRIPE_API_URL). No usa baseURL: siempre se le pasan URLs absolutas.
// Lleva su propio Bearer para no mezclarse con el token de sesion de Odoo.
const axiosPayment = axios.create();

axiosPayment.defaults.headers.common["Authorization"] = `Bearer ${token_payment}`;

// Headers para peticiones que no usan axios (fetch).
const paymentHeaders = (headers = {}) => ({
  Authorization: `Bearer ${token_payment}`,
  ...headers,
});

// El API de pagos responde la URL de Stripe en distintas formas segun el
// endpoint. Si el backend contesta con un redirect 303, XHR/fetch lo siguen
// solos y la URL final queda en responseURL, pero el estandar borra el
// fragmento (#fidkdWxOYHw...) que Stripe necesita: esa URL mutilada produce
// "This link is incomplete". Por eso solo se acepta el fallback si conserva el
// fragmento; el endpoint debe responder JSON con la url.
const getCheckoutUrl = (response, requestedUrl) => {
  const url =
    response?.data?.data?.url ||
    response?.data?.url ||
    response?.data?.payload?.url ||
    null;

  if (url) return url;

  const responseURL = response?.request?.responseURL;
  if (!responseURL || responseURL === requestedUrl) return null;
  if (
    responseURL.includes("checkout.stripe.com") &&
    !responseURL.includes("#")
  ) {
    throw new Error(
      "El API de pagos respondio con un redirect 303: la URL de Stripe pierde el fragmento y queda incompleta. El endpoint debe responder JSON { url: session.url }."
    );
  }
  return responseURL;
};

export { axiosPayment, paymentHeaders, getCheckoutUrl };
